module.exports = __webpack_public_path__ + "static/media/profile_new.23ee171d.svg";